import { setFulfilled, setPending } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { FirstRunSuggestedGroupsLoadAction } from '../../domains/firstRunSuggestedGroups/actions.types';

import type { ViewerFirstRunSuggestedGroupIdSets } from './types';

export const initialState: ViewerFirstRunSuggestedGroupIdSets = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<ViewerFirstRunSuggestedGroupIdSets, FirstRunSuggestedGroupsLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'FRE_SUGGESTED_GROUPS.LOAD_PENDING': {
      return setPending();
    }
    case 'FRE_SUGGESTED_GROUPS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.viewerSuggestedGroupIdSets);
    default:
      return state;
  }
};

export default reducer;
